import { render, staticRenderFns } from "./AdminTopNavItemsMobile.vue?vue&type=template&id=61bc6e50"
import script from "./AdminTopNavItemsMobile.vue?vue&type=script&lang=js"
export * from "./AdminTopNavItemsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports